
jQuery(window).on('load', function() {
  jQuery(".layout--slider_elementti").each(function(index, element){
    jQuery(this).find(".swiper-container").addClass("swinstance-" + index);
    jQuery(this).find(".swiper-button-prev").addClass("btn-prev-" + index);
    jQuery(this).find(".swiper-button-next").addClass("btn-next-" + index);
    var slider = new Swiper(".swinstance-" + index, {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 24,
    slidesPerGroup: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".btn-next-" + index,
      prevEl: ".btn-prev-" + index
    },
  
    breakpoints: {
  
      650: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
        spaceBetween: 40,
      }
    }
  });
});
});